<div class="modal-header">
  <h4 class="modal-title">Appoint Auditor</h4>

</div>

<div class="modal-body">
  <form [formGroup]="AuditorForm" (ngSubmit)="onSubmitAuditor()">
    <div class="row">
      <!-- Auditor Type -->
      <div class="col-lg-6 mb-2">
        <label class="form-label">Auditor Type<span class="text-danger">*</span></label>
        <select class="form-control" formControlName="auditorTypeId" (change)="onChangeAuditorType()" 
                [ngClass]="{ 'invalid-input': AuditorForm.get('auditorTypeId')?.errors && isSubmit }">
          <option value="" disabled>Select Auditor Type</option>
          <option *ngFor="let data of auditors" [value]="data.id">{{ data.name }}</option>
        </select>
      </div>

      <!-- Auditor Name -->
      <div class="col-lg-6 mb-2">
        <label class="form-label">Auditor Name<span class="text-danger">*</span></label>
        <select class="form-control" formControlName="auditorId" (change)="onAuditor()" 
                [ngClass]="{ 'invalid-input': AuditorForm.get('auditorId')?.errors && isSubmit }">
          <option value="" disabled>Select Auditor Name</option>
          <option *ngFor="let data of auditorName" [value]="data.iUserID">{{ data.name }}</option>
        </select>
      </div>

      <!-- Designation -->
      <div class="col-lg-6 mb-2" *ngIf="AuditorForm.get('auditorDesignation')?.value">
        <label class="form-label">Auditor's Designation</label>
        <input type="text" class="form-control" formControlName="auditorDesignation" readonly />
      </div>

      <!-- Email -->
      <div class="col-lg-6 mb-2">
        <label class="form-label">Auditor's Email</label>
        <input type="email" class="form-control" formControlName="auditorEmail" readonly />
      </div>

      <!-- Mobile No -->
      <div class="col-lg-6 mb-2">
        <label class="form-label">Auditor's Mobile No.</label>
        <input type="text" class="form-control" formControlName="auditorMobile" readonly />
      </div>

      <!-- Submit Button -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel Click')">Close</button>
        <button type="submit" class="btn btn-success" *ngIf="!isReadonly">Submit</button>
      </div>
    </div>
  </form>
</div>